<template>
  <div class="input__wrap" :style="`width: ${width};`" :disabled="disabled">
    <span class="input__text">{{title}}{{ (required) ? '*' : '' }}</span>
    <Multiselect :value="value"
                 :options="options"
                 :class="validationClass"
                 :multiple="true"
                 label="name"
                 track-by="id"
                 :searchable="true"
                 :disabled="disabled"
                 :required="required"
                 :placeholder="placeholder"
                 selectLabel=""
                 selectedLabel=""
                 deselectLabel=""
                 :allow-empty="allowEmpty"
                 :maxHeight="400"
                 :tabindex="1"
                 :options-limit="50"
                 @open="open"
                 @select="addItem"
                 @remove="removeItem"
    >
      <template  slot="option" slot-scope="{ option }">
        <div class="option" v-if="isUsers">
          <div class="user-avatar option__avatar">
            <img v-if="option.avatar && option.avatar.file_size"
                 :src="option.avatar.url" :alt="option.name">
            <img v-else src="/img/avatar-thumb.png" :alt="option.name">
          </div>
          <div class="option__name">
            {{ option.name }}
            <div v-if="option.position">
              &nbsp;&nbsp;{{ option.position.name }}
            </div>
          </div>
        </div>
        <div class="option__name" v-if="!isUsers">
          {{ option.name }}
        </div>
      </template>
      <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
      <!-- eslint-disable-next-line vue/no-unused-vars -->
      <template slot="noResult" slot-scope="{ option }">Ничего не найдено</template>
      <!-- eslint-disable-next-line vue/no-unused-vars -->
      <template slot="noOptions" slot-scope="{ option }">Список пуст</template>
    </Multiselect>
    <transition name="scaleDown">
            <span v-if="valid.type" class="input__valid" :class="'input__valid_' + valid.type">
                {{ valid.message }}
                <img v-if=" valid.type === 'error' " src="/img/svg/error_icon.svg" alt="Ошибка" class="input__valid__icon">
                <img v-if=" valid.type === 'warning' " src="/img/svg/warning_icon.svg" alt="Внимание" class="input__valid__icon">
                <img v-if=" valid.type === 'success' " src="/img/svg/success_icon.svg" alt="Успешно" class="input__valid__icon">
            </span>
    </transition>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'app-select-multiple',
  components: {
    Multiselect
  },
  props: {
    value: Array,
    title: String,
    placeholder: {
      type: String,
      default: 'Не выбрано'
    },
    width: {
      type: String,
      default: '100%'
    },
    options: Array,
    isUsers: {
      type: Boolean,
      default: false
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    multiple: Boolean,
    disabled: Boolean,
    required: Boolean,
    valid: {
      type: Object,
      default: () => {
        return { type: null, message: '' }
      }
    }
  },
  computed: {
    validationClass () {
      return {
        input_error: this.valid.type && this.valid.type === 'error',
        input_warning: this.valid.type && this.valid.type === 'warning',
        input_success: this.valid.type && this.valid.type === 'success'
      }
    }
  },
  methods: {
    addItem (value) {
      this.$emit('add-item', value)
    },
    removeItem (value) {
      this.$emit('remove-item', value)
    },
    open () {
      this.$emit('open')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.input {
  &__wrap {
    position: relative;
    display: block;

    &[disabled] {
      pointer-events: none;

      .input__text {
        color: $color_deactive;
      }

      .input {
        border: 1px solid $color_deactive;
      }
    }
  }

  &__text {
    display: block;
    margin-bottom: 10px;
    color: $font_color_second;
    font-weight: 600;
  }

  &__valid {
    display: block;
    position: absolute;
    z-index: 99;
    top: auto;
    bottom: auto;
    transform: translateY(-5px) scaleY(1);
    transform-origin: top;
    left: 0;
    width: 100%;
    font-size: 14px;
    padding: 5px 15px 0 15px;
    color: $font_color_alt;
    border-radius: 0 0 3px 3px;
    transition: .3s;

    &__icon {
      position: absolute;
      top: calc(50% - 12.5px);
      left: auto;
      right: -35px;
      animation: fadeIn .3s linear;
    }

    &_error {
      background-color: $color_error;
    }

    &_warning {
      background-color: $color_warning;
    }

    &_success {
      background-color: $color_success;
    }
  }

  &[disabled] {
    background: $color_main;
  }

  &:hover {
    border: 1px solid $color_second-light;
  }

  &:focus {
    box-shadow: inset 0 4px 4px rgba(23, 63, 125, 0.25);
  }
}

.option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  &__avatar {
    margin-right: 10px;
    @include size(52px)
  }

  &__name {
    white-space: normal;
    line-height: 1.25;
  }
}
</style>
